import "./RockWoolSandwichPanels.module.css";
import Header from "@/reusable_sections/Header";
import ProductDetails from "./sections/ProductDetails";
import Footer from "@/reusable_sections/Footer";
export default function RockWoolSandwichPanelsPage() {
  return <div>
      <Header />
      <ProductDetails />
      <Footer />
    </div>;
}